var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "insights-kpi-cards" },
    _vm._l(_vm.kpis, function (kpi) {
      return _c("div", { key: kpi.key, staticClass: "kpi-card" }, [
        _c("div", { staticClass: "kpi-icon" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v(_vm._s(kpi.icon)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "kpi-body" },
          [
            _c("div", { staticClass: "kpi-label" }, [
              _vm._v(_vm._s(_vm.$t(kpi.labelKey))),
            ]),
            _vm._v(" "),
            !_vm.loading
              ? _c("div", { staticClass: "kpi-value" }, [
                  _vm._v(_vm._s(kpi.value)),
                ])
              : _c("a-skeleton-input", {
                  style: { width: "90px" },
                  attrs: { active: true, size: "small" },
                }),
          ],
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }